import { createSelector } from '@ngrx/store';

import { User } from '@models/swagger';
import { State } from './reducer';
import { selectGetUserByIdState } from '../selectors';

export const getData = createSelector(selectGetUserByIdState, (state: State) => state.data);

export const getError = createSelector(selectGetUserByIdState, (state: State) => state.error);

export const getLoading = createSelector(selectGetUserByIdState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: User) => T) =>
  createSelector(selectGetUserByIdState, (state: State) => fn(state.data));
